export enum JobKitItemType {
  PART = 'P',
  LABOUR = 'L',
  TEXT = 'T',
  MISCELLANEOUS = 'M',
}

// Summary type for list views
export interface JobKitSummary {
  id: number;
  name: string;
  keycode: string;
  description: string;
  totalCost: number | null;
  discount: number | null;
  summarize: boolean;
  createdAt: string;
}

// Detail type for detail view
export interface JobKitDetail {
  id: number;
  tenantId: number;
  keycode: string;
  name: string;
  description: string | null;
  totalCost: number | null;
  discount: number | null;
  summarize: boolean;
  invoiceText: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface JobKitItem {
  id: number;
  tenantId: number;
  jobKitId: number;
  type: JobKitItemType;
  code: string | null;
  description: string | null;
  quantity: number | null;
  unitCost: number | null;
  totalCost: number | null;
  discount: number | null;
  labourCategoryId: number | null;
  labourCategoryName: string | null;
  createdAt: string;
  updatedAt: string;
}

export type JobKitCreateDto = Omit<JobKitDetail, 'id' | 'createdAt' | 'updatedAt' | 'tenantId'>;

export type JobKitItemCreateDto = Omit<
  JobKitItem,
  'id' | 'createdAt' | 'updatedAt' | 'tenantId' | 'jobKitId' | 'labourCategoryName'
>;

export interface JobKitSearchDto {
  page: number;
  limit: number;
  query: string;
  sortField: string;
  sortOrder: string;
}
